"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = bySpeaker;

var _lodash = require("lodash");

var _groupTermsBy = _interopRequireDefault(require("./groupTermsBy"));

var _constants = require("../constants");

var _Term = _interopRequireDefault(require("../Term"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 *
 * @param source {[Term]} a horizontal list of terms. Assumed to be the output
 *                        of transcriptCompiler.
 * @returns {Term}
 *    a single node with the property speakers, a set
 *    and a value of an array of Terms, each is a group of a single
 *    speaker's words, and their name as a property.
 *    {Term: props {speakers: Set([strings])},
 *                 values: [
 *                   Term: props {speaker: string},
 *                         values: [Term ... Term] (words/punct from original)
 *                 ]
 *   }
 */
function bySpeaker(source) {
  var sourceBySpeaker = (0, _groupTermsBy["default"])(source.value, function (term, series, last) {
    if (term.isMeta) {
      if (term.meta === 'turn') {
        return term.value;
      }

      if (last) {
        return last.key;
      }

      return _constants.DEFAULT_SPEAKER;
    }

    if (last) {
      return last.key;
    }

    return _constants.DEFAULT_SPEAKER;
  });
  /**
   * at this point the series will be in the form
   * [
   *  {
   *    key: speakerName,
   *    terms [
   *        Term (memo node with speaker),
   *        Term (word) ... (term.word);
   *      ]
   *    ]
   *  } ... (key, terms) ...
   * ]
   */

  var speakers = new Set((0, _lodash.map)(sourceBySpeaker, 'key'));
  var sValue = sourceBySpeaker.map(function (_ref) {
    var key = _ref.key,
        terms = _ref.terms;
    var value = terms.slice(0);
    if (value[0].isMeta && value[0].meta === 'turn') value.shift();
    return new _Term["default"]({
      props: {
        type: 'turn',
        speaker: key
      },
      value: value
    });
  });
  return new _Term["default"]({
    value: sValue,
    type: 'words by speaker',
    props: {
      speakers: speakers
    }
  });
}